const LoadingSpinner = () => {
    return (
        <div className="loader-container w-100 position-relative">
            <span className="loader position-absolute"></span>
        </div>
    );
};

export default LoadingSpinner;
